<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <product-header @export-pdf="exportPDF" @export-csv="exportCSV" @print-table="printTable"
        @refresh="refreshList"></product-header>

      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input type="text" placeholder="Recherche" class="dark-input" v-model="searchQuery" />
                <a href="javascript:void(0);" class="btn btn-searchset" @click.prevent="applyFilters"><i
                    data-feather="search" class="feather-search"></i></a>
              </div>
            </div>
            <div class="search-path">
              <a class="btn btn-filter" id="filter_search" v-on:click="filter = !filter" :class="{ setclose: filter }">
                <vue-feather type="filter" class="filter-icon"></vue-feather>
                <span><img src="@/assets/img/icons/closes.svg" alt="img" /></span>
              </a>
            </div>
            <div class="form-sort">
              <vue-feather type="sliders" class="info-img"></vue-feather>
              <vue-select :options="Sortby" id="sortby" placeholder="Par Date" />
            </div>
          </div>
          <!-- /Filter -->
          <div class="card mb-0" :style="{ display: filter ? 'block' : 'none' }" id="filter_inputs">
            <div class="card-body pb-0">
              <div class="row">
                <div class="col-lg-12 col-sm-12">
                  <div class="row">
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label class="form-label">Produit</label>
                        <div class="input-with-icon">
                          <vue-feather type="box" class="info-img"></vue-feather>
                          <vue-select :options="ChooseFilter" id="choosefilter" placeholder="Choisir un produit"
                            v-model="activeFilters.name" />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label class="form-label">Catégorie</label>
                        <div class="input-with-icon">
                          <vue-feather type="stop-circle" class="info-img"></vue-feather>
                          <vue-select :options="CategroyFilter" id="categroyfilter" placeholder="Choisir une Catégorie"
                            v-model="activeFilters.category" />
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-4 col-sm-12 col-12">
                      <div class="input-blocks row">

                        <label class="form-label">Quantité (min - max)</label>
                        <div class="input-with-icon" style="max-width: fit-content;">
                          <i class="fas fa-sort-numeric-up info-img"></i>
                          <div class="d-flex gap-3 align-items-end">
                            <div class="flex-fill">
                              <input type="number" min="0" class="form-control" :placeholder="`${minQuantity}`"
                                v-model.number="selectedMinQuantity" />
                            </div>
                          </div>
                        </div>
                        <div class="input-with-icon" style="max-width: fit-content;">
                          <div class="d-flex gap-3 align-items-end">
                            <i class="fas fa-sort-numeric-up info-img"></i>
                            <div class="flex-fill">
                              <input type="number" min="0" class="form-control" :placeholder="`${maxQuantity}`"
                                v-model.number="selectedMaxQuantity" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks my-4">
                        <a class="btn btn-filters ms-auto" @click.prevent="applyFilters">
                          <i data-feather="search" class="feather-search"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Filter -->
          <div class="table-responsive product-list">
            <a-table class="table datanew table-hover table-center mb-0" :columns="columns" :data-source="filteredData"
              :row-selection="{}">
              <template #bodyCell="{ column, record, text }">
                <template v-if="column.key === 'image'">
                  <div class="product-thumb-wrapper">
                    <img
                      v-if="getPrimaryImageUrl(record)"
                      :src="getPrimaryImageUrl(record)"
                      alt="Image du produit"
                      class="product-thumb-img"
                    />
                    <div v-else class="product-thumb-placeholder">
                      <vue-feather type="image" size="16"></vue-feather>
                    </div>
                  </div>
                </template>
                <template v-else-if="column.key === 'statut_achat'">
                  <div>
                    <span :class="record.statut_achat
                      ? 'badge badge-linesuccess'
                      : 'badge badge-linedanger'
                      ">{{ record.statut_achat ? "Actif" : "Inactif" }}</span>
                  </div>
                </template>
                <template v-else-if="column.key === 'statut_vente'">
                  <div>
                    <span :class="record.statut_vente
                      ? 'badge badge-linesuccess'
                      : 'badge badge-linedanger'
                      ">{{ record.statut_vente ? "Actif" : "Inactif" }}</span>
                  </div>
                </template>
                <template v-else-if="column.key === 'action'">
                  <div class="action-buttons">
                    <button
                      type="button"
                      class="btn btn-icon btn-light btn-sm"
                      @click.prevent="openProductDetails(record)"
                      title="Voir le détail"
                    >
                      <vue-feather type="eye" size="16"></vue-feather>
                    </button>
                    <router-link
                      class="btn btn-icon btn-outline-primary btn-sm"
                      to="/produits/modification-produit"
                      @click="selectProduct(record)"
                      title="Modifier"
                    >
                      <vue-feather type="edit-2" size="16"></vue-feather>
                    </router-link>
                    <button
                      type="button"
                      class="btn btn-icon btn-outline-danger btn-sm"
                      @click="showConfirmation(record.id)"
                      title="Supprimer"
                    >
                      <vue-feather type="trash-2" size="16"></vue-feather>
                    </button>
                  </div>
                </template>
                <template v-else>
                  <span>{{ formatCellValue(column, record, text) }}</span>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>
  <product-list-modal></product-list-modal>
  <div class="modal fade" ref="productViewModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Détails du produit</h5>
          <button type="button" class="btn-close" aria-label="Close" @click="hideProductDetails"></button>
        </div>
        <div class="modal-body" v-if="viewProduct">
          <div v-if="modalImagePaths.length" class="modal-image-gallery mb-4">
            <div class="modal-main-image">
              <img
                v-if="currentModalImageUrl"
                :src="currentModalImageUrl"
                alt="Image du produit"
              />
              <div v-else class="modal-main-placeholder">
                <vue-feather type="image" size="36"></vue-feather>
              </div>
            </div>
            <div v-if="modalImagePaths.length > 1" class="modal-thumb-list">
              <button
                v-for="(path, idx) in modalImagePaths"
                :key="`${path}-${idx}`"
                type="button"
                class="modal-thumb-btn"
                :class="{ active: idx === modalActiveImageIndex }"
                @click="setModalImage(idx)"
              >
                <img
                  v-if="resolveImageUrl(path)"
                  :src="resolveImageUrl(path)"
                  alt="Miniature du produit"
                />
                <div v-else class="modal-thumb-placeholder">
                  <vue-feather type="image" size="16"></vue-feather>
                </div>
              </button>
            </div>
          </div>
          <dl class="row mb-0">
            <dt class="col-sm-4">Référence</dt>
            <dd class="col-sm-8">{{ viewProduct.referance_produit || `PRD-${viewProduct.id}` }}</dd>

            <dt class="col-sm-4">Nom</dt>
            <dd class="col-sm-8">{{ viewProduct.nom || "—" }}</dd>

            <dt class="col-sm-4">Description</dt>
            <dd class="col-sm-8">{{ viewProduct.description || "—" }}</dd>

            <dt class="col-sm-4">Catégorie</dt>
            <dd class="col-sm-8">{{ viewProduct.categorie_produit || "—" }}</dd>

            <dt class="col-sm-4">Entrepôt par défaut</dt>
            <dd class="col-sm-8">{{ viewProduct.entrepot_par_defaut != null ? viewProduct.entrepot_par_defaut : "—" }}</dd>

            <dt class="col-sm-4">Prix de vente</dt>
            <dd class="col-sm-8">{{ formatCurrency(viewProduct.prix_vente) }}</dd>

            <dt class="col-sm-4">Prix d'achat</dt>
            <dd class="col-sm-8">{{ formatCurrency(viewProduct.prix_achat) }}</dd>

            <dt class="col-sm-4">Stock optimal</dt>
            <dd class="col-sm-8">{{ viewProduct.stock_optimal != null ? viewProduct.stock_optimal : "—" }}</dd>

            <dt class="col-sm-4">Statut d'achat</dt>
            <dd class="col-sm-8">
              <span :class="viewProduct.statut_achat ? 'badge bg-success-subtle text-success' : 'badge bg-danger-subtle text-danger'">
                {{ viewProduct.statut_achat ? "Actif" : "Inactif" }}
              </span>
            </dd>

            <dt class="col-sm-4">Statut de vente</dt>
            <dd class="col-sm-8">
              <span :class="viewProduct.statut_vente ? 'badge bg-success-subtle text-success' : 'badge bg-danger-subtle text-danger'">
                {{ viewProduct.statut_vente ? "Actif" : "Inactif" }}
              </span>
            </dd>

            <dt class="col-sm-4">Surface</dt>
            <dd class="col-sm-8">{{ viewProduct.surface || "—" }}</dd>

            <dt class="col-sm-4">Volume</dt>
            <dd class="col-sm-8">{{ viewProduct.volume || "—" }}</dd>

            <dt class="col-sm-4">Poids</dt>
            <dd class="col-sm-8">{{ viewProduct.poids || "—" }}</dd>

            <dt class="col-sm-4">Seuil d'alerte</dt>
            <dd class="col-sm-8">{{ viewProduct.seuil_alerte_stock != null ? viewProduct.seuil_alerte_stock : "—" }}</dd>

            <dt class="col-sm-4">Taux TVA</dt>
            <dd class="col-sm-8">{{ viewProduct.taux_tva != null ? `${viewProduct.taux_tva}%` : "—" }}</dd>

            <dt class="col-sm-4">Créé le</dt>
            <dd class="col-sm-8">{{ viewProduct.CreatedOn || "—" }}</dd>
          </dl>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="hideProductDetails">Fermer</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getProductsData, getProductsDataWithStock, deleteProduct } from "@/services/productsService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getCompanyLogoDataUrl, getCompanyData } from "@/services/companyService";
import { toast } from "vue3-toastify";
import { Modal } from "bootstrap";
const columns = [
  {
    title: "Image",
    dataIndex: "primaryImagePath",
    key: "image",
    sorter: false,
  },
  {
    title: "Réf",
    dataIndex: "referance_produit",
    sorter: {
      compare: (a, b) =>
        String(a.referance_produit || "").localeCompare(
          String(b.referance_produit || "")
        ),
    },
  },
  {
    title: "Produit",
    dataIndex: "nom",
    sorter: {
      compare: (a, b) =>
        String(a.nom || "").localeCompare(String(b.nom || "")),
    },
  },

  {
    title: "Description",
    dataIndex: "description",
    sorter: {
      compare: (a, b) =>
        String(a.description || "").localeCompare(String(b.description || "")),
    },
  },
  {
    title: "Entrepôt",
    dataIndex: "entrepot_par_defaut",
    sorter: {
      compare: (a, b) =>
        String(a.entrepot_par_defaut || "").localeCompare(
          String(b.entrepot_par_defaut || "")
        ),
    },
  },
  {
    title: "Dimensions",
    dataIndex: "dimensions",
    sorter: {
      compare: (a, b) =>
        String(a.dimensions || "").localeCompare(String(b.dimensions || "")),
    },
  },
  {
    title: "Prix de Vente",
    dataIndex: "prix_vente",
    sorter: {
      compare: (a, b) => (Number(a.prix_vente) || 0) - (Number(b.prix_vente) || 0),
    },
  },
  {
    title: "Stock Optimal",
    dataIndex: "stock_optimal",
    sorter: {
      compare: (a, b) => (Number(a.stock_optimal) || 0) - (Number(b.stock_optimal) || 0),
    },
  },
  {
    title: "Status d'Achat",
    dataIndex: "statut_achat",
    key: "statut_achat",
    sorter: {
      compare: (a, b) => (a.statut_achat === b.statut_achat ? 0 : a.statut_achat ? -1 : 1),
    },
  },
  {
    title: "Status de Vente",
    dataIndex: "statut_vente",
    key: "statut_vente",
    sorter: {
      compare: (a, b) => (a.statut_vente === b.statut_vente ? 0 : a.statut_vente ? -1 : 1),
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
const data = [];
import Swal from "sweetalert2";
export default {
  data() {
    return {
      filter: false,
      Sortby: ["Par Date", "14 09 23", "11 09 23"],
      ChooseFilter: ["Tous les produits"],
      CategroyFilter: ["Toutes les catégories"],
      data,
      columns,
      selectedProduct: {},
      filteredData: [],
      activeFilters: {
        name: null,
        category: null,
      },
      searchQuery: "",
      // Quantité range
      minQuantity: 0,
      maxQuantity: 0,
      selectedMinQuantity: null,
      selectedMaxQuantity: null,
      stockMap: {}, // { [produitId]: total_stock }
      viewProduct: null,
      productViewModalInstance: null,
      modalActiveImageIndex: 0,
    };
  },
  methods: {
    extractPrimaryImage(entity) {
      if (!entity) return null;
      if (entity.image_produit) {
        return entity.image_produit;
      }
      const images = this.normalizeImages(entity);
      const first = images.find((img) => img.path);
      return first ? first.path : null;
    },
    normalizeImages(entity) {
      if (!entity || !Array.isArray(entity.images)) {
        return [];
      }
      return entity.images
        .map((img) => {
          if (!img) return null;
          if (typeof img === "string") {
            return { path: img };
          }
          return img.path ? img : null;
        })
        .filter((img) => img && img.path);
    },
    getAllImagePaths(entity) {
      const paths = [];
      if (entity && entity.image_produit) {
        paths.push(entity.image_produit);
      }
      this.normalizeImages(entity).forEach((img) => {
        if (img.path && !paths.includes(img.path)) {
          paths.push(img.path);
        }
      });
      return paths;
    },
    resolveImageUrl(path) {
      if (!path) return null;
      if (/^https?:\/\//i.test(path)) {
        return path;
      }
      const base = (process.env.VUE_APP_URL || window.location.origin).replace(/\/$/, "");
      const normalizedPath = path.startsWith("storage/") ? path : `storage/${path}`.replace(/\/{2,}/g, "/");
      return `${base}/${normalizedPath}`;
    },
    getPrimaryImageUrl(record) {
      const path =
        record && record.primaryImagePath
          ? record.primaryImagePath
          : this.extractPrimaryImage(record);
      return this.resolveImageUrl(path);
    },
    async toDataURLFromPublicPath(path) {
      try {
        const url = this.resolveImageUrl(path);
        if (!url) return null;
        const res = await fetch(url);
        if (!res.ok) return null;
        const blob = await res.blob();
        return await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      } catch (e) {
        return null;
      }
    },
    openProductDetails(record) {
      this.viewProduct = record;
      this.modalActiveImageIndex = 0;
      this.$nextTick(() => {
        if (!this.productViewModalInstance && this.$refs.productViewModal) {
          this.productViewModalInstance = new Modal(this.$refs.productViewModal, {
            backdrop: "static",
          });
        }
        this.productViewModalInstance && this.productViewModalInstance.show();
      });
    },
    hideProductDetails() {
      this.productViewModalInstance && this.productViewModalInstance.hide();
      this.modalActiveImageIndex = 0;
    },
    setModalImage(index) {
      if (index >= 0 && index < this.modalImagePaths.length) {
        this.modalActiveImageIndex = index;
      }
    },
    formatCellValue(column, record, text) {
      if (!column || !record) {
        return "—";
      }
      const value =
        text !== undefined
          ? text
          : column.dataIndex
          ? record[column.dataIndex]
          : null;
      if (value === null || value === undefined || value === "") {
        return "—";
      }
      if (column.dataIndex === "prix_vente") {
        return this.formatCurrency(value);
      }
      return value;
    },
    formatCurrency(value) {
      if (value === null || value === undefined || value === "") return "—";
      const number = Number(value);
      if (Number.isNaN(number)) return value;
      return number.toLocaleString("fr-FR", {
        style: "currency",
        currency: "MAD",
        minimumFractionDigits: 2,
      });
    },
    async loadCompanyLogoDataUrl() {
      // Try protected API first, then public storage fallback
      try {
        const dataUrl = await getCompanyLogoDataUrl('logo');
        if (dataUrl) return dataUrl;
      } catch (e) {
        // ignore
      }
      try {
        const comp = await getCompanyData();
        const filePath = comp?.data?.logo || comp?.data?.logo_small;
        const dataUrl = await this.toDataURLFromPublicPath(filePath);
        if (dataUrl) return dataUrl;
      } catch (e) {
        // ignore
      }
      return null;
    },
    refreshList() {
      this.getProductsData().then(() => this.loadStockQuantities());
    },
    exportCSV() {
      const rows = this.filteredData.length ? this.filteredData : this.data;
      const headers = [
        "Réf",
        "Produit",
        "Description",
        "Entrepôt",
        "Dimensions",
        "Prix de Vente",
        "Stock Optimal",
        "Status d'Achat",
        "Status de Vente",
      ];
      const csv = [
        headers.join(","),
        ...rows.map((r) =>
          [
            r.referance_produit || `PRD-${r.id}`,
            r.nom || "",
            r.description || "",
            r.entrepot_par_defaut != null ? r.entrepot_par_defaut : "",
            r.dimensions || "",
            r.prix_vente != null ? r.prix_vente : "",
            r.stock_optimal != null ? r.stock_optimal : "",
            r.statut_achat ? "Actif" : "Inactif",
            r.statut_vente ? "Actif" : "Inactif",
          ]
            .map((v) => `"${String(v).replace(/"/g, '""')}"`)
            .join(",")
        ),
      ].join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `produits_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    async exportPDF() {
      try {
        const rows = this.filteredData.length ? this.filteredData : this.data;

        if (!rows.length) {
          console.warn('No data to export');
          return;
        }

        const doc = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "a4"
        });

        // Load logo only (no title or metadata)
        const dataUrl = await this.loadCompanyLogoDataUrl().catch((err) => {
          console.warn('Failed to load logo:', err);
          return null;
        });

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const headerHeight = 26; // space reserved for the logo area
        const margin = 12;

        // Header drawing function with centered logo only
        const drawHeader = () => {
          if (!dataUrl) return;
          const yPos = 8;
          const logoW = 42; // mm
          const logoH = 16; // mm
          const xPos = (pageWidth - logoW) / 2; // center horizontally
          try {
            const format = dataUrl.startsWith("data:image/png") ? "PNG" : "JPEG";
            doc.addImage(dataUrl, format, xPos, yPos, logoW, logoH);
          } catch (error) {
            console.error('Error adding logo to PDF:', error);
          }
        };

        // Format currency
        const formatPrice = (price) => {
          if (price == null || price === '') return '-';
          return `${Number(price).toFixed(2)} MAD`;
        };

        // Prepare table data
        const body = rows.map((r) => [
          r.referance_produit || `PRD-${r.id}`,
          r.nom || '-',
          r.description || '-',
          r.entrepot_par_defaut != null ? r.entrepot_par_defaut : '-',
          r.dimensions || '-',
          formatPrice(r.prix_vente),
          r.stock_optimal != null ? r.stock_optimal.toString() : '-',
          r.statut_achat ? "✓ Actif" : "✗ Inactif",
          r.statut_vente ? "✓ Actif" : "✗ Inactif",
        ]);

        // Generate table
        autoTable(doc, {
          startY: headerHeight,
          head: [[
            "Référence",
            "Produit",
            "Description",
            "Entrepôt",
            "Dimensions",
            "Prix de Vente",
            "Stock Optimal",
            "Achat",
            "Vente",
          ]],
          body,
          headStyles: {
            fillColor: [30, 104, 163],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 9,
            halign: 'center',
          },
          styles: {
            fontSize: 8,
            cellPadding: 3,
            overflow: 'linebreak',
            cellWidth: 'wrap',
          },
          columnStyles: {
            0: { cellWidth: 25, fontStyle: 'bold' },  // Référence
            1: { cellWidth: 30 },                      // Produit
            2: { cellWidth: 45 },                      // Description
            3: { cellWidth: 25 },                      // Entrepôt
            4: { cellWidth: 25 },                      // Dimensions
            5: { cellWidth: 30, halign: 'right' },    // Prix
            6: { cellWidth: 22, halign: 'center' },   // Stock
            7: { cellWidth: 20, halign: 'center' },   // Achat
            8: { cellWidth: 20, halign: 'center' },   // Vente
          },
          alternateRowStyles: {
            fillColor: [245, 245, 245]
          },
          didDrawPage: () => {
            drawHeader();

            // Footer with page numbers
            const pageCount = doc.internal.getNumberOfPages();
            const currentPage = doc.internal.getCurrentPageInfo().pageNumber;

            doc.setFontSize(9);
            doc.setTextColor(120);

            // Page number
            doc.text(
              `Page ${currentPage} sur ${pageCount}`,
              pageWidth - margin,
              pageHeight - 8,
              { align: "right" }
            );

            // Left footer (optional metadata)
            doc.text(
              "Généré par votre système",
              margin,
              pageHeight - 8,
              { align: "left" }
            );

            doc.setTextColor(0);
          },
          margin: {
            left: margin,
            right: margin,
            top: headerHeight + 4,
            bottom: 15
          },
        });

        // Save with formatted filename
        const timestamp = new Date().toISOString().slice(0, 10);
        const filename = `produits_${timestamp}.pdf`;
        doc.save(filename);

      } catch (error) {
        console.error('Error generating PDF:', error);
        // Optional: Show user-friendly error message
        throw new Error('Échec de la génération du PDF. Veuillez réessayer.');
      }
    },
    printTable() {
      const rows = this.filteredData.length ? this.filteredData : this.data;
      const win = window.open("", "_blank");
      const tableHtml = `
        <html><head><title>Liste des Produits</title>
        <style>table{width:100%;border-collapse:collapse}th,td{border:1px solid #ccc;padding:6px;text-align:left}</style>
        </head><body>
        <h3>Liste des Produits</h3>
        <table>
          <thead>
            <tr>
              <th>Réf</th><th>Produit</th><th>Description</th><th>Entrepôt</th><th>Dimensions</th><th>Prix de Vente</th><th>Stock Optimal</th><th>Status d'Achat</th><th>Status de Vente</th>
            </tr>
          </thead>
          <tbody>
            ${rows
          .map(
            (r) => `
                <tr>
                  <td>${r.referance_produit || `PRD-${r.id}`}</td>
                  <td>${r.nom || ""}</td>
                  <td>${r.description || ""}</td>
                  <td>${r.entrepot_par_defaut != null ? r.entrepot_par_defaut : ""}</td>
                  <td>${r.dimensions || ""}</td>
                  <td>${r.prix_vente != null ? r.prix_vente : ""}</td>
                  <td>${r.stock_optimal != null ? r.stock_optimal : ""}</td>
                  <td>${r.statut_achat ? "Actif" : "Inactif"}</td>
                  <td>${r.statut_vente ? "Actif" : "Inactif"}</td>
                </tr>`
          )
          .join("")}
          </tbody>
        </table>
        </body></html>`;
      win.document.open();
      win.document.write(tableHtml);
      win.document.close();
      setTimeout(() => { try { win.focus(); win.print(); } catch (e) { /* ignore */ } }, 100);
    },
    getErrorMessage(error) {
      const data = error && error.response && error.response.data;
      if (!data) return (error && error.message) || "Une erreur est survenue.";
      if (typeof data === "string") return data;
      if (data.errors && typeof data.errors === "object") {
        const firstKey = Object.keys(data.errors)[0];
        const firstVal = data.errors[firstKey];
        if (Array.isArray(firstVal) && firstVal.length) return firstVal[0];
        if (typeof firstVal === "string") return firstVal;
      }
      if (data.error) return data.error;
      if (data.message) return data.message;
      return "Une erreur est survenue.";
    },
    updateFilters() {
      const names = Array.from(
        new Set(this.data.map((p) => (p.nom ? p.nom.toString() : "")))
      )
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b, "fr"));
      const categories = Array.from(
        new Set(
          this.data.map((p) => (p.categorie_produit ? p.categorie_produit.toString() : ""))
        )
      )
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b, "fr"));
      this.ChooseFilter = ["Tous les produits", ...names];
      this.CategroyFilter = ["Toutes les catégories", ...categories];
    },
    applyFilters() {
      const name = this.activeFilters.name && this.activeFilters.name !== "Tous les produits" ? this.activeFilters.name : null;
      const category = this.activeFilters.category && this.activeFilters.category !== "Toutes les catégories" ? this.activeFilters.category : null;
      const q = (this.searchQuery || "").toString().toLowerCase().trim();
      this.filteredData = this.data.filter((p) => {
        const okName = name ? p.nom === name : true;
        const okCategory = category ? p.categorie_produit === category : true;
        const qty = this.stockMap[p.id] ?? 0;
        const minQ = this.selectedMinQuantity != null ? Number(this.selectedMinQuantity) : null;
        const maxQ = this.selectedMaxQuantity != null ? Number(this.selectedMaxQuantity) : null;
        const okQty = (minQ === null || qty >= minQ) && (maxQ === null || qty <= maxQ);
        const okQuery = q
          ? [
            p.referance_produit,
            p.nom,
            p.description,
            p.categorie_produit,
            p.prix_vente,
            p.entrepot_par_defaut,
            p.dimensions,
          ]
            .filter(Boolean)
            .map((v) => v.toString().toLowerCase())
            .some((v) => v.includes(q))
          : true;
        return okName && okCategory && okQty && okQuery;
      });
    },
    async loadStockQuantities() {
      try {
        const list = await getProductsDataWithStock();
        const map = {};
        let maxQ = 0;
        (list || []).forEach((p) => {
          const q = Number(p.total_stock || 0);
          map[p.id] = q;
          if (q > maxQ) maxQ = q;
        });
        // Ensure we have an entry for all products (0 if missing)
        this.data.forEach((p) => {
          if (map[p.id] == null) map[p.id] = 0;
        });
        this.stockMap = map;
        this.minQuantity = 0;
        this.maxQuantity = maxQ;
        if (this.selectedMinQuantity == null) this.selectedMinQuantity = this.minQuantity;
        if (this.selectedMaxQuantity == null) this.selectedMaxQuantity = this.maxQuantity;
        this.applyFilters();
      } catch (error) {
        console.error(error);
        // Keep quantity filters disabled gracefully
      }
    },
    showConfirmation(id) {
      Swal.fire({
        title: "Es-tu sûr de vouloir supprimer ce produit ?",
        text: "Cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprime-le !",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        cancelButtonText: "Annuler",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await deleteProduct(id);
            if (localStorage.getItem("products") != null) {
              let products = JSON.parse(localStorage.getItem("products"));
              products = products.filter((item) => item.id !== id);
              const jsonData = JSON.stringify(products);
              localStorage.setItem("products", jsonData);
            }

            this.data = this.data.filter((item) => item.id !== id);
            this.updateFilters();
            this.applyFilters();
            Swal.fire({
              icon: "success",
              title: "Supprimer!",
              text: "Le produit a été supprimer",
              confirmButtonClass: "btn btn-success",
            });
          } catch (error) {
            console.error(error);
            toast.error(this.getErrorMessage(error));
          }
        }
      });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    async getProductsData() {
      this.data = [];
      if (localStorage.getItem("products") != null) {
        const data = JSON.parse(localStorage.getItem("products"));
        data.map((m) => {
          const images = this.normalizeImages(m);
          const primaryImagePath = this.extractPrimaryImage(m);
          this.data.push({
            id: m.id,
            societe_id: m.societe_id,
            nom: m.nom,
            description: m.description,
            dimensions: m.dimensions,
            prix_vente_minimum: m.prix_vente_minimum,
            categorie_produit: m.categorie_produit,
            stock_optimal: m.stock_optimal,
            surface: m.surface,
            volume: m.volume,
            poids: m.poids,
            prix_achat: m.prix_achat,
            prix_vente: m.prix_vente,
            referance_produit: m.referance_produit,
            categorie_produit_id:
              m.categorie_produit_id || (m.categorie ? m.categorie.id : null),
            image_produit: m.image_produit,
            images,
            primaryImagePath,
            statut_achat: m.statut_achat,
            statut_vente: m.statut_vente,
            seuil_alerte_stock: m.seuil_alerte_stock,
            taux_tva: m.taux_tva,
            entrepot_par_defaut: m.entrepot_par_defaut,
            CreatedOn: this.formatDate(m.created_at),
          });
        });
      } else {
        try {
          const data = await getProductsData();
          data.map((m) => {
            const images = this.normalizeImages(m);
            const primaryImagePath = this.extractPrimaryImage(m);
            this.data.push({
              id: m.id,
              societe_id: m.societe_id,
              nom: m.nom,
              description: m.description,
              dimensions: m.dimensions,
              categorie_produit: m.categorie_produit,
              prix_vente_minimum: m.prix_vente_minimum,
              stock_optimal: m.stock_optimal,
              surface: m.surface,
              volume: m.volume,
              poids: m.poids,
              prix_achat: m.prix_achat,
              prix_vente: m.prix_vente,
              referance_produit: m.referance_produit,
              categorie_produit_id:
                m.categorie_produit_id || (m.categorie ? m.categorie.id : null),
              image_produit: m.image_produit,
              images,
              primaryImagePath,
              statut_achat: m.statut_achat,
              statut_vente: m.statut_vente,
              seuil_alerte_stock: m.seuil_alerte_stock,
              taux_tva: m.taux_tva,
              entrepot_par_defaut: m.entrepot_par_defaut,
              CreatedOn: this.formatDate(m.created_at),
            });
          });
        } catch (error) {
          console.error(error);
          toast.error(this.getErrorMessage(error));
        }
      }
      // initialize filtered list and filters
      this.filteredData = [...this.data];
      this.updateFilters();
    },

    selectProduct(item) {
      this.selectedProduct = item;
      localStorage.setItem("product", JSON.stringify(this.selectedProduct));
    },
  },
  computed: {
    modalImagePaths() {
      if (!this.viewProduct) {
        return [];
      }
      return this.getAllImagePaths(this.viewProduct);
    },
    currentModalImageUrl() {
      const path = this.modalImagePaths[this.modalActiveImageIndex] || null;
      return this.resolveImageUrl(path);
    },
  },
  mounted() {
    this.getProductsData().then(() => {
      this.loadStockQuantities();
    });
  },
  beforeUnmount() {
    if (this.productViewModalInstance) {
      this.productViewModalInstance.hide();
      this.productViewModalInstance = null;
    }
  },
  watch: {
    searchQuery() {
      this.applyFilters();
    },
    'activeFilters.name'() {
      this.applyFilters();
    },
    'activeFilters.category'() {
      this.applyFilters();
    },
    selectedMinQuantity() {
      this.applyFilters();
    },
    selectedMaxQuantity() {
      this.applyFilters();
    },
  },
};
</script>
<style scoped>
.input-with-icon {
  position: relative;
}

/* vue-select padding to avoid overlapping icon */
.input-with-icon :deep(.vs__dropdown-toggle) {
  padding-left: 36px !important;
}

.product-thumb-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f8fb;
  margin: 0 auto;
}

.product-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-thumb-placeholder {
  color: #9aa0a6;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.btn-icon.btn-sm {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.modal-image-gallery {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.modal-main-image {
  width: 100%;
  min-height: 220px;
  border-radius: 12px;
  border: 1px solid #edf0f5;
  background: #f9fbfd;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.modal-main-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.modal-main-placeholder {
  color: #9aa0a6;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.modal-thumb-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.modal-thumb-btn {
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 4px;
  background: #fff;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.modal-thumb-btn:hover {
  border-color: #d0d7e1;
  transform: translateY(-1px);
}

.modal-thumb-btn.active {
  border-color: #1e68a3;
  background: rgba(30, 104, 163, 0.08);
}

.modal-thumb-btn img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.modal-thumb-placeholder {
  color: #9aa0a6;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
</style>
